// libs
import { connect } from 'react-redux';

// components
import ModelWidget from './ModelWidget';

// selectors
import { getModelWidgetData, getProductImagesAspectRatio } from 'shared/store/details/selectors';

const mapStateToProps = (state: any) => {
  return {
    modelData: getModelWidgetData(state),
    aspectRatio: getProductImagesAspectRatio(state),
  };
};

export default connect(mapStateToProps)(ModelWidget);
